import { atomWithReset } from "jotai/utils";

export const rejectBuyerDocumentModalAtom = atomWithReset<{
  visible: boolean;
  buyerId: string | null;
}>({
  visible: false,
  buyerId: null
});
